import { render } from "./App.vue?vue&type=template&id=24a35fe3"
const script = {}

import "./App.vue?vue&type=style&index=0&id=24a35fe3&lang=less"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__